// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.closeBtn {
  color: #234099 !important;
  font-size: 40px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-audit-search/agent-audit-search.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,eAAA;EACA,mBAAA;AACF","sourcesContent":[".closeBtn {\r\n  color: #234099 !important;\r\n  font-size: 40px;\r\n  margin-bottom: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
